import { createContext, useContext, useReducer } from "react";
import IAdvancedFilterOptionsContext from "../../contracts/IAdvancedFilterOptionsContext";
import { IAdvancedFilterOptionsAction } from "../../contracts/IAdvancedFilterOptionsAction";

const initialFilterOptionsData: IAdvancedFilterOptionsContext = {
    filterOperators: [],
    stringFilters: [],
    dateFilters: [],
    numberFilters: [],
    filterOperatorValues: []
};

export const AdvancedFilterOptionsContext = createContext<{
    advancedFilterOptions: IAdvancedFilterOptionsContext;
    dispatch: React.Dispatch<IAdvancedFilterOptionsAction>;
} | null>(null);

const AdvancedFilterOptionsProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [advancedFilterOptions, dispatch] = useReducer(
        advancedFilterOptionsReducer,
        initialFilterOptionsData
    );
    return (
        <AdvancedFilterOptionsContext.Provider value={{ advancedFilterOptions, dispatch }}>
            {children}
        </AdvancedFilterOptionsContext.Provider>
    );
};
export default AdvancedFilterOptionsProvider;

export const advancedFilterOptionsReducer = (
    state: IAdvancedFilterOptionsContext,
    action: IAdvancedFilterOptionsAction
) => {
    switch (action.type) {
        case "UPDATE": {
            return {
                ...state,
                ...action.payload,
            };
        }
        default:
            return state;
    }
};
